import { CircleIndicator } from 'Components/Indicator/CircleIndicator';
import { Text } from 'Components/Text/Text';
import { RiskRating, getRiskRatingVariantColor, numberAsRiskRatingString, numberAsRiskScore } from 'Models/RiskRating';

import styles from './CircleIndicatorRiskRating.module.css';

interface CircleIndicatorRiskRatingProps {
    /** If undefined, 'standard' is used. */
    pageVariant?: 'standard' | 'dashboard';
    /** If undefined, `RiskRating.UNRATED` is used. */
    riskRating?: RiskRating;
}

/** Renders a colored circle, where the color corresponds with the given risk rating, next to the user-friendly name for the risk rating. */
export const CircleIndicatorRiskRating = (props: CircleIndicatorRiskRatingProps) => {
    const pageVariant = props.pageVariant ?? 'standard';
    const riskRating = props.riskRating ?? RiskRating.UNRATED;

    return (
        <div className={styles.circleAndTextContainer}>
            <CircleIndicator variant={getRiskRatingVariantColor(numberAsRiskScore(riskRating))} />
            <Text noStyles color={pageVariant === 'standard' ? 'blue' : 'white'}>
                {numberAsRiskRatingString(riskRating)}
            </Text>
        </div>
    );
};
